import { IItemRightsCollection } from "../../../../Global/Base/Rights/RightTypes";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { Control } from "../Controls/Control";
import { IMasterableFrame } from "./Frames/FrameInterfaces";

export interface FrameSelChanged {
    sender?: IMasterableFrame;
    objectName: string;
    actualObject: OWObject;
}

export interface ListFrameNewObject {
    className: string;
    actualObject: OWObject;
    id: string;
}

export interface IActualObjectChangedEventArgs {
    previousActualObject: OWObject;
    actualObject: OWObject;
}

export interface IHideButtons {
    readonly cancel?: boolean;
    readonly copy?: boolean;
    readonly delete?: boolean;
    readonly edit?: boolean;
    readonly insert?: boolean;
    readonly prev?: boolean;
    readonly next?: boolean;
    readonly refresh?: boolean;
    readonly save?: boolean;
    readonly search?: boolean;
    readonly workflow?: boolean;
    readonly graph?: boolean;
    readonly settings?: boolean;
}

export class HideButtons implements IHideButtons {
    public cancel: boolean;
    public copy: boolean;
    public delete: boolean;
    public edit: boolean;
    public insert: boolean;
    public prev: boolean;
    public next: boolean;
    public refresh: boolean;
    public save: boolean;
    public search: boolean;
    public workflow: boolean;
    public graph?: boolean;
    public settings: boolean;

    constructor(hideButtons: string[], hideButtonsOverride?: IHideButtons) {
        //pokud hideButtons obsahuje dany text, tak do promenne priradi true, tzn. HideButtons.Cancel == true, znamena ano skutecne skryj dane tlacitko
        this.cancel = hideButtons.indexOf("fbcancel") !== -1;
        this.copy = hideButtons.indexOf("fbcopy") !== -1;
        this.delete = hideButtons.indexOf("fbdelete") !== -1;
        this.edit = hideButtons.indexOf("fbedit") !== -1;
        this.insert = hideButtons.indexOf("fbinsert") !== -1;
        this.prev = hideButtons.indexOf("fbprev") !== -1;
        this.next = hideButtons.indexOf("fbnext") !== -1;
        this.refresh = hideButtons.indexOf("fbrefresh") !== -1;
        this.save = hideButtons.indexOf("fbsave") !== -1;
        this.search = hideButtons.indexOf("fbsearch") !== -1;
        this.workflow = hideButtons.indexOf("fbworkflow") !== -1;
        this.graph = hideButtons.indexOf("fbgraph") !== -1;
        this.settings = hideButtons.indexOf("fbsettings") !== -1;

        if (hideButtonsOverride) {
            if (hideButtonsOverride.cancel != null)
                this.cancel = hideButtonsOverride.cancel;
            if (hideButtonsOverride.copy != null)
                this.copy = hideButtonsOverride.copy;
            if (hideButtonsOverride.delete != null)
                this.delete = hideButtonsOverride.delete;
            if (hideButtonsOverride.edit != null)
                this.edit = hideButtonsOverride.edit;
            if (hideButtonsOverride.insert != null)
                this.insert = hideButtonsOverride.insert;
            if (hideButtonsOverride.prev != null)
                this.prev = hideButtonsOverride.prev;
            if (hideButtonsOverride.next != null)
                this.next = hideButtonsOverride.next;
            if (hideButtonsOverride.refresh != null)
                this.refresh = hideButtonsOverride.refresh;
            if (hideButtonsOverride.save != null)
                this.save = hideButtonsOverride.save;
            if (hideButtonsOverride.search != null)
                this.search = hideButtonsOverride.search;
            if (hideButtonsOverride.workflow != null)
                this.workflow = hideButtonsOverride.workflow;
            if (hideButtonsOverride.graph != null)
                this.graph = hideButtonsOverride.graph;
            if (hideButtonsOverride.settings != null)
                this.settings = hideButtonsOverride.settings;
        }
    }
}

/**
 * Interface prvku/akce a kolekce jeho práv
 */
export interface IControlWithRights {
    /**
     * Instance prvku/akce
     */
    control: Control;
    /**
     * Kolekce práv k vyhodnocení patřící k prvku/akce
     */
    itemRightsCollection: IItemRightsCollection;
    /**
     * Příznak, zda se akce vztahuje k záznamu (zda mají práva vyhodnocovat i když není vybraný žádný záznam)
     */
    evaluateRightsWithoutContext?: boolean;
}

export interface IDomStructureElement extends IControlWithRights {
    childControls: IDomStructureElement[];
}
